import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { GoogleMapsAutocompleteDirective } from '@app/directives/google-maps-autocomplete/google-maps-autocomplete.directive';
import { safeUTC } from '@app/extensions/moment-extensions';
import { dateFormatPipe } from '@app/pipes/datepipe';
import { MedpaceDatepickerComponent } from '@components/atoms/medpace-datepicker/medpace-datepicker.component';
import { EditableCardMode } from '@components/atoms/medpace-editable-card/medpace-editable-card.component';
import { TransferDataFormGroup } from '@components/request/travel-request-card/form-groups/detail-form-groups/travel/car-service-request.formgroup';
import {
    MdsCardComponent,
    MdsCardContentComponent,
    MdsDropdownComponent,
    MdsIconButtonComponent,
    MdsTextFieldComponent,
} from '@medpacesoftwaredevelopment/designsystem';
import { TransferData, TransferData_DTO } from '@models/transferData';
import { PersistentFormControl } from '@utility/persistent-forms';
import { MdsOptionGeneric } from '@utility/utility';
import { utc } from 'moment';

export function fromDTO(dto: TransferData_DTO): TransferData {
    return <TransferData>{
        ...dto,
        pickupDateTime: safeUTC(dto.pickupDateTime),
    };
}
export function toDTO(value: TransferData): TransferData_DTO {
    return <TransferData_DTO>{
        ...value,
        pickupDateTime: value.pickupDateTime.toISOString(),
    };
}

@Component({
    selector: 'medpace-transfer-data',
    templateUrl: './transfer-data.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        dateFormatPipe,
        MdsTextFieldComponent,
        MedpaceDatepickerComponent,

        MdsDropdownComponent,
        MdsCardComponent,
        MdsCardContentComponent,
        GoogleMapsAutocompleteDirective,
        MdsIconButtonComponent,
    ],
})
export class TransferDataComponent {
    @Input() public mode: EditableCardMode;
    @Input() public timeOptions: MdsOptionGeneric<number>[];
    @Input() formGroup: TransferDataFormGroup;
    @Input() public index: number;
    @Output() public removeEvent = new EventEmitter<number>();

    protected remove() {
        this.removeEvent.emit(this.index);
    }
    protected minutesSinceMidnightToMoment(minutesSinceMidnight: number) {
        return utc().startOf('day').add(minutesSinceMidnight, 'minutes');
    }

    googleMapsAutocompletePlaceChange(place: google.maps.places.Place, formControl: PersistentFormControl<string>) {
        formControl.setValue(place.formattedAddress);
    }
}
